import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import tomocredit_logo from "assets/logo_t.svg";
import { varParser } from "utils";
import PushChatBubble from "./PushChatBubble";
import "../../styles/marketing-dashboard.css";

const PushChatBubblePreview = () => {
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState(false);
  const message = useSelector((state) => state.pushBatching.message);
  const header = useSelector((state) => state.pushBatching.header);
  const batchName = useSelector((state) => state.pushBatching.batchName);
  const emailList = useSelector((state) => state.pushBatching.emailList);
  useEffect(() => {}, [message, emailList]);
  return (
    <div className="flex flex-col justify-center mx-auto text-center">
      {editMode ? (
        <div className="px-10">
          <PushChatBubble
            enabled={editMode}
            error={error}
            setError={setError}
          />
        </div>
      ) : (
        <>
          <span className="mx-auto text-center text-gray-600">
            {batchName ? (
              <span>{`batch name : ${batchName}`}</span>
            ) : (
              <small className="text-gray-600">
                <span className="text-red-500">error: </span>
                  no batch name found
              </small>
            )}
          </span>
          {emailList && emailList.length ? (
            <div className="bg-gray-200 px-2 py-2 rounded-lg">
              <div
                className="rounded-t-lg "
                style={{ backgroundColor: "#fffefc" }}
              >
                <div className="flex flex-row items-center justify-items-stretch p-1">
                  <div className="m-1 p-1 bg-black rounded-md">
                    <img
                      style={{ width: "0.9em" }}
                      src={tomocredit_logo}
                      alt="tomo_credit_logo"
                    />
                  </div>
                  <div className="">
                    <input
                      style={{ backgroundColor: "#fffefc" }}
                      placeholder="add a notification header*"
                      className="mx-2 my-auto px-1"
                      value={
                        emailList && header
                          ? varParser(header, emailList)
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="ml-auto my-auto mr-2 font-gray">
                    <small>now</small>
                  </div>
                </div>

                <div
                  className="rounded-b-lg py-1"
                  style={{ backgroundColor: "#f9f9f9" }}
                >
                  <textarea
                    name=""
                    className="ml-2 mr-2 m-1 pl-3 pr-3 pt-2 pb-2"
                    cols="50"
                    rows="3"
                    placeholder="Welcome to TomoCredit..."
                    disabled
                    value={
                      emailList && message
                        ? varParser(message, emailList)
                        : ""
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <small className="text-gray-600">
              <span className="text-red-500">error: </span>
                no csv file uploaded
            </small>
          )}
        </>
      )}
      <div className="flex flex-row justify-end my-3">
        <span>
          <button
            type="button"
            className="focus:outline-none focus:border-none active:outline-none active:border-none"
            onClick={() => setEditMode(!editMode)}
          >
            <small className={editMode ? "text-red-500" : "text-green-500"}>
              {editMode ? "preview" : "edit"}
              <i className="fas fa-edit mx-1" />
            </small>
          </button>
        </span>
      </div>
    </div>
  );
};

export default PushChatBubblePreview;
